import React from 'react';
import { Select } from 'antd';
import { gql } from '@apollo/client';
import { useQuery } from 'hooks/apollo';

const { Option, OptGroup } = Select;

const QUERY = gql`
  query {
    timezoneGroups { name timezones { key name } }
  }
`;

const TimezoneSelect = (props) => {
  const { loading, data: { timezoneGroups = [] } = {} } = useQuery(QUERY, {
    fetchPolicy: 'cache-first',
  });

  return (
    <Select loading={loading} showSearch optionFilterProp="children" {...props}>
      {timezoneGroups.map(({ name: groupName, timezones }) => (
        <OptGroup key={groupName} label={groupName}>
          {timezones.map(({ key, name }) => (
            <Option key={key} value={key}>{name}</Option>
          ))}
        </OptGroup>
      ))}
    </Select>
  );
};

export default TimezoneSelect;
